import { I18n } from 'react-redux-i18n';

export default value => (value === true ? I18n.t('application.yes') : I18n.t('application.no'));



// WEBPACK FOOTER //
// ./src/components/normalize/BooleanNormalize.js